import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmojiU1f4681f3fb200d1f4bb1IconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmojiU1f4681f3fb200d1f4bb1Icon = ({ className, ...props }: EmojiU1f4681f3fb200d1f4bb1IconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.1101 13.4406C16.1101 13.4406 17.7635 13.4578 18.0815 11.7614C18.4167 9.97392 17.1293 9.68173 17.1293 9.68173L16.1101 13.4406Z"
      fill="#EDBD82"
    />
    <path
      d="M4.89527 9.99284C4.89527 9.99284 3.25558 9.77456 3.77465 11.8164C4.22496 13.5902 5.91621 13.4389 5.91621 13.4389L4.89527 9.99284Z"
      fill="#EDBD82"
    />
    <path
      d="M10.5737 13.2206L4.97745 11.2234C4.97745 11.2234 3.81729 7.37859 4.95854 4.47562C5.86604 2.16734 7.89589 0.730464 10.7353 0.66687C13.7706 0.59812 15.8846 1.89062 16.866 4.24874C18.052 7.09499 16.8093 11.1787 16.8093 11.1787L10.5737 13.2206Z"
      fill="#312D2D"
    />
    <path
      d="M6.2529 6.41437C5.98478 6.58452 6.00368 8.88077 5.85071 9.86905C5.68915 10.9123 4.96899 11.2045 4.96899 11.2045C4.96899 11.2045 5.35399 12.7308 5.95899 13.8944C6.78915 15.4911 8.4529 17.1256 11.0138 17.1273C13.1451 17.1273 14.374 15.9947 15.187 15.015C16.3952 13.5592 16.8077 11.1805 16.8077 11.1805C16.8077 11.1805 16.3832 10.8453 16.0859 9.87077C15.737 8.73296 15.7954 6.51233 15.4895 6.30265C15.1835 6.09296 13.5009 6.22702 10.7079 6.26483C8.49243 6.29577 6.51931 6.24593 6.2529 6.41437Z"
      fill="#F9DDBD"
    />
    <path
      d="M11.019 12.088C10.481 12.0983 10.2799 11.9161 10.0891 12.1103C9.91554 12.2873 10.0702 12.54 10.3607 12.7652C10.7543 13.0711 11.3644 13.0608 11.679 12.7772C11.9918 12.497 12.1276 12.2616 11.9248 12.0897C11.7219 11.9178 11.5673 12.0794 11.019 12.088Z"
      fill="#DBA689"
    />
    <path
      d="M6.68417 8.7536C6.82339 8.97876 7.29777 8.62469 8.05058 8.60235C8.66589 8.58516 9.20386 9.02344 9.33105 8.62469C9.4823 8.15204 8.97698 7.94751 8.06261 7.99048C7.12761 8.03516 6.49855 8.4511 6.68589 8.7536H6.68417Z"
      fill="#312D2D"
    />
    <path
      d="M12.6105 8.72608C12.9215 8.81202 13.1587 8.58686 13.793 8.62983C14.3859 8.66936 14.9651 8.93061 15.137 8.73811C15.3089 8.54561 14.8672 8.07983 13.8892 7.9853C13.0075 7.89936 12.4695 8.13655 12.4042 8.32905C12.3389 8.52155 12.4798 8.69171 12.6087 8.7278L12.6105 8.72608Z"
      fill="#312D2D"
    />
    <path
      d="M8.04021 9.39811C7.32005 9.38779 7.0399 10.0117 7.08286 10.4517C7.12583 10.8917 7.45927 11.3128 8.09349 11.3008C8.69677 11.2904 9.02849 10.8917 9.02849 10.3658C9.02849 9.83982 8.70537 9.40842 8.03849 9.39811H8.04021Z"
      fill="#3F4040"
    />
    <path
      d="M13.8118 9.37749C13.2738 9.32077 12.7788 9.70062 12.8011 10.3451C12.8252 11.0653 13.456 11.2922 13.8015 11.2922C14.2965 11.2922 14.6952 10.9261 14.7055 10.4001C14.7158 9.8089 14.415 9.4428 13.8135 9.37921H13.8118V9.37749Z"
      fill="#3F4040"
    />
    <path
      d="M1.85282 21.1733C1.71704 20.8914 2.42689 18.5883 3.89298 17.9094C5.35907 17.2305 9.23142 17.0534 9.23142 17.0534C9.23142 17.0534 9.6697 18.547 11.4469 18.4594C13.2241 18.3734 13.4492 16.9709 13.4492 16.9709C13.4492 16.9709 17.3302 17.3594 18.3992 17.8217C20.1936 18.5986 20.2795 20.6542 20.0974 21.0375C19.9684 21.3108 15.3416 21.2524 10.7783 21.3022C6.21501 21.352 1.85282 21.1733 1.85282 21.1733Z"
      fill="#00BDA3"
    />
    <path
      d="M11.8989 16.0944L2.05388 16.9434C2.05388 16.9434 1.53998 14.4427 2.12091 13.7294C2.70185 13.0144 3.68326 13.1484 4.80044 13.1038C5.30404 13.0831 17.404 13.0453 17.8819 13.0814C18.7533 13.1484 19.4494 13.0522 19.7347 13.9305C19.9701 14.6575 19.5112 16.5206 19.5112 16.5206L11.8989 16.0961V16.0944Z"
      fill="#E0E0E0"
    />
    <path
      d="M2.83595 21.273C2.6847 21.2266 2.05392 17.2992 1.96455 16.3848C1.87517 15.4705 2.21033 14.2192 3.19173 14.1745C4.17314 14.1298 17.5003 14.1298 18.26 14.1522C19.0197 14.1745 19.7553 14.8895 19.5542 16.1614C19.3531 17.4333 18.7258 21.218 18.5728 21.2506C18.2102 21.3297 3.19345 21.3847 2.83595 21.273Z"
      fill="#B0B0B0"
    />
    <path
      d="M11.1666 17.337C9.97549 17.3353 9.48221 18.1792 9.43064 18.9114C9.35846 19.9289 9.91533 20.2314 11.1374 20.2314C12.3594 20.2314 12.8853 20.0251 12.796 18.8581C12.7341 18.0537 12.1721 17.3387 11.1666 17.337Z"
      fill="#858585"
    />
    <path
      d="M11.7251 18.7773C11.9039 18.7722 12.0173 18.6329 12.0225 18.4284C12.0208 18.2273 11.8678 18.1053 11.7028 18.1087C11.5378 18.1122 11.4312 18.2686 11.4278 18.4542C11.4244 18.6398 11.5636 18.7842 11.7251 18.7773Z"
      fill="#B0B0B0"
    />
    <path
      d="M10.5684 18.7636C10.7265 18.7361 10.8382 18.6106 10.797 18.3665C10.742 18.1362 10.589 18.0503 10.4051 18.1019C10.2212 18.1534 10.192 18.394 10.2281 18.535C10.271 18.7017 10.412 18.7894 10.5684 18.7636Z"
      fill="#B0B0B0"
    />
    <path
      d="M10.185 19.2087C10.0939 19.3514 10.5168 19.7347 11.1785 19.7278C11.9227 19.7209 12.2321 19.262 12.0585 19.1331C11.8179 18.9561 11.811 19.2981 11.163 19.3067C10.515 19.3153 10.3604 18.9303 10.185 19.2087Z"
      fill="#B0B0B0"
    />
  </svg>
);

export default EmojiU1f4681f3fb200d1f4bb1Icon;
